import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 路由导航
export default new Router({
  // mode: 'history',
  mode: 'hash', // 路由模式，使用hash模式
  routes: [
    {
      path: '', // 路由路径为空，表示一级路由
      name: 'home',
      component: () => import('./views/Home.vue'), // 首页组件懒加载
      children: [
        {
          path: '/', // 子路由路径为'/'，表示默认显示的子页面
          name: 'Pages',
          component: () => import('./views/pages/index.vue'), // 子页面组件懒加载
          meta: {
            index: 10, // 用于页面排序
            alive: true, // 用于缓存页面
            header: 1 // 用于设置头部
          }
        },
        {
          path: '/NoticeDetails',
          name: 'NoticeDetails',
          component: () => import('./views/pages/noticeDetails.vue'), // 公告详情页面组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/Notice',
          name: 'Notice',
          component: () => import('./views/pages/notice.vue'), // 公告列表页面组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/Market',
          name: 'Market',
          component: () => import('./views/market/index.vue'), // 行情页面组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/Exchange',
          name: 'Exchange',
          component: () => import('./views/exchange/index.vue'), // 交易页面组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/ExchangeKline',
          name: 'ExchangeKline',
          component: () => import('./views/exchange/exchangeKline.vue'), // 交易页面组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/My',
          name: 'My',
          component: () => import('./views/my/index.vue'), // 我的页面组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/My/invite',
          name: 'Invite',
          component: () => import('./views/my/invite.vue'), // 邀请好友页面组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/My/assets',
          name: 'Assets',
          component: () => import('./views/my/assets.vue'), // 钱包页面组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/My/recharge',
          name: 'Recharge',
          component: () => import('./views/my/recharge.vue'), // 充值页面组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/My/withdrawal',
          name: 'Withdrawal',
          component: () => import('./views/my/withdrawal.vue'), // 提币页面组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/My/details',
          name: 'Details',
          component: () => import('./views/my/details.vue'), // 提币页面组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/My/records',
          name: 'Records',
          component: () => import('./views/my/records.vue'), // 提币明细页面组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/My/wecord',
          name: 'Wecord',
          component: () => import('./views/my/wecord.vue'), // 充币明细页面组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/system',
          name: 'System',
          component: () => import('./views/system/index.vue'), // 系统设置页面组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/system/versions',
          name: 'Versions',
          component: () => import('./views/system/versions.vue'), // 系统设置页面组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/system/safety',
          name: 'Safety',
          component: () => import('./views/system/safety.vue'), // 安全中心页面组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/system/update',
          name: 'Update',
          component: () => import('./views/system/update.vue'), // 修改登录密码/充值登录密码/修改交易密码/重置交易密码页面组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/system/service',
          name: 'Service',
          component: () => import('./views/system/service.vue'), // 联系客服页面组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/system/aboutUs',
          name: 'AboutUs',
          component: () => import('./views/system/aboutUs.vue'), // 关于我们页面组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/My/flashExchange',
          name: 'FlashExchange',
          component: () => import('./views/my/flashExchange.vue'), // 闪兑页面组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/My/flashExchangeDt',
          name: 'FlashExchangeDt',
          component: () => import('./views/my/flashExchangeDt.vue'), // 闪兑历史记录页面组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/My/group',
          name: 'Group',
          component: () => import('./views/my/group.vue'), // 我的团队页面组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/My/income',
          name: 'Income',
          component: () => import('./views/my/income.vue'), // 我的收益页面组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/My/key',
          name: 'Key',
          component: () => import('./views/my/key.vue'), // 备份密钥页面组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/My/transfer',
          name: 'Transfer',
          component: () => import('./views/my/transfer.vue'), // 转账组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/My/incomeDeta',
          name: 'IncomeDeta',
          component: () => import('./views/my/incomeDeta.vue'), // 收益明细组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/My/transferDe',
          name: 'TransferDe',
          component: () => import('./views/my/transferDe.vue'), // 转账记录组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/subscription',
          name: 'Subscription',
          component: () => import('./views/subscription/index.vue'), // 认购页面组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/Subscription/record',
          name: 'Record',
          component: () => import('./views/subscription/record.vue'), // 通证管理记录页面组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/Subscription/particulars',
          name: 'Particulars',
          component: () => import('./views/subscription/particulars.vue'), // 通证管理明细页面组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/Subscription/addToSubs',
          name: 'AddToSubs',
          component: () => import('./views/subscription/addToSubs.vue'), // 我要认购页面组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/member/login',
          name: 'Member',
          component: () => import('./views/member/index.vue'), // 登录页面组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/member/register',
          name: 'Register',
          component: () => import('./views/member/register.vue'), // 注册页面组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/member/addLogin',
          name: 'AddLogin',
          component: () => import('./views/member/addLogin.vue'), // 切换账户登录页面组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/member/retrieve',
          name: 'Retrieve',
          component: () => import('./views/member/retrieve.vue'), // 忘记密码组件懒加载
          meta: {
            index: 10,
          }
        },
        {
          path: '/member/cut',
          name: 'Cut',
          component: () => import('./views/member/cut.vue'), // 切换账户组件懒加载
          meta: {
            index: 10,
          }
        }
      ],
      meta: {
        index: 5,
      }
    }
  ]
})
